<template>
  <div class="page-container">
    <Before v-if="contractCurrent" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
    Before: () => import('@/components/apply/Before'),
  },
  computed: {
    ...mapState('contract', { contractCurrent: 'current' }),
  },
  created() {
    _meta({
      titles: ['서비스이용준비완료'],
    })
  },
}
</script>
<style lang="scss" scoped>
#section__complete {
  text-align: center;

  .clap {
    width: 100%;
    height: 210px;
    object-fit: contain;
  }
}
</style>
